<template>
    <div class="lms__superadmin_users_profile_edit_activitylog">
        <component-list
            v-if="profileUserId"
            :component-table="LmsSuperadminUsersProfileEditActivityLogTable"
            :component-table-name="'activity-log'"
            :filter-search-queryable="true"
            :get-pagination-getter="'getLmsUserAccountActivityLogPagination'"
            :get-items-getter="'getLmsUserAccountActivityLog'"
            :get-items-dispatch="'lmsUserAccountActivityLogGet'"
            :get-items-dispatch-params="{ id: profileUserId }"
            :item-name="['record', 'records']"
            :table-preferences-active="true"
        />
    </div>
</template>

<script>

import ComponentList from '@/components/default/shared/ComponentList'
import LmsSuperadminUsersProfileEditActivityLogTable from '@/components/lms/superadmin/users/profile/edit/LmsSuperadminUsersProfileEditActivityLogTable'

export default {
  name: 'lms-superadmin-users-profile-edit-activity-log',
  components: { ComponentList },
  data () {
    return {
      LmsSuperadminUsersProfileEditActivityLogTable
    }
  },
  computed: {
    profileUserId () {
      return this.$store.getters.getLmsSuperadminWorkspaceUserProfileUserId
    }
  }
}
</script>
